// Quando aprire la mini-app pubblica invece di BOP.
// - Sui domini delle pagine di prenotazione (prenota.bonacinaceramiche.it, prenota.bgres.it)
//   sempre: un cliente che digita solo il dominio non deve arrivare al login di BOP.
// - Sugli altri domini solo per /prenota e /prenota/…: /prenotazioni-xyz resta dentro BOP.
export function apreMiniAppPubblica(hostname: string, pathname: string): boolean {
  if (hostname.toLowerCase().startsWith('prenota.')) return true;
  return pathname === '/prenota' || pathname.startsWith('/prenota/');
}
